
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jackpot_deposit/[prefix]",
      function () {
        return require("private-next-pages/jackpot_deposit/[prefix].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jackpot_deposit/[prefix]"])
      });
    }
  